export enum VoteResultSelectValues {
  Accepted = 'accepted',
  Rejected = 'rejected',
  All = 'all',
}
